/*eslint-disable*/ export const messages = JSON.parse("{\"textfield.label.optional\":[\"Valfritt\"]}");
//# sourceMappingURL=messages.mjs.map